<template>
    <div class="loading-holder" v-show="!displayReady">
      <div>Please wait as we are processing the information.</div>
      <img :src="loadingImg" />
    </div>
    <div class="additional-info-manager" v-show="displayReady">
      <div>
        <div class="row additional-info-header">
          <div class="col-2">
            <div class="edit-icon" v-show="!isEditingPrimaryInfo">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" stroke="#3c763d" stroke-width="2px"/>
              </svg>
            </div>
          </div>
          <div class="col-8 text-center">
          {{ pageTitle }}
          </div>
          <div class="col-2">
            <div class="edit-icon text-end" v-show="!isEditingPrimaryInfo">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" stroke="#3c763d" stroke-width="2px"/>
              </svg>
            </div>
          </div>
        </div>
        <component
        v-for="question in currentPageActiveQuestions"
        :key="question.field"
        :field="question.field"
        :is="question.type"
        :question="question"
        :model-value="info[question.field]"
        :errors="infoErrors[question.field]"
        :allow-change="allowConsumerInfoEdit"
        :default="question.default"
        @update:model-value="changeField(question.field, $event)"
        :ref="setQuestionRef"
        ></component>
        <div class="row justify-content-center additional-info-footer">
          <div class="back-button-holder col-auto"><button class="btn btn-outline-primary" @click="backPage" :disabled="isEditingPrimaryInfo" v-show="currentPage > 0 && !isPrepped">Back</button></div>
          <div class="next-button-holder col-auto" v-if="currentPage === pages.length - 1">
            <button class="btn btn-success" @click="getReady" v-if="!isPrepped" :disabled="isEditingPrimaryInfo">Next</button>
            <button class="btn btn-primary" @click="save" :disabled="isEditingPrimaryInfo" v-else>If All Consumer Information Is Confirmed,<br> CLICK HERE.</button>
          </div>
          <div class="next-button-holder col-auto" v-else>
            <button class="btn btn-success" @click="nextPage" :disabled="isEditingPrimaryInfo">Next</button>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { nextTick } from 'vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import AreaOfStudyOptionButtons from './basic-elements/AreaOfStudyOptionButtons.vue'
import DropDown from './basic-elements/DropDown.vue'
import OptionButtons from './basic-elements/OptionButtons.vue'
import HiddenField from './basic-elements/HiddenField.vue'
import OnlyLabel from './basic-elements/OnlyLabel.vue'

export default {
  name: 'AdditionalInfoManager',
  props: ['consumerId'],
  components: {
    AreaOfStudyOptionButtons,
    DropDown,
    HiddenField,
    OnlyLabel,
    OptionButtons
  },
  data () {
    return {
      isPrepped: false,
      saveTriggered: false,
      inactivesPrepared: false,
      questionRefs: {},
      currentPage: 0,
      loadingImg: process.env.BASE_URL + 'loading.gif'
    }
  },
  methods: {
    async setInactiveDefaults () {
      if (this.inactivesPrepared) {
        this.inactiveQuestions.forEach((q) => {
          this.setField({ field: q.field, value: q.default })
        })
        this.activeQuestions.filter((q) => typeof q.default !== 'undefined' && this.info[q.field] === q.default).forEach((q) => {
          this.setField({ field: q.field, value: null })
        })
      }
    },
    async prepareInactives () {
      await nextTick()
      for (var inactiveQ of this.inactiveQuestions) {
        if (this.info[inactiveQ.field] && this.info[inactiveQ.field] !== '' && this.info[inactiveQ.field] !== inactiveQ.default && (!this.info[inactiveQ.dependsOn.field] || this.info[inactiveQ.dependsOn.field] === '')) {
          this.setField({ field: inactiveQ.dependsOn.field, value: inactiveQ.dependsOn.values[0] })
        }
        if (this.info[inactiveQ.field] === inactiveQ.default && (!this.info[inactiveQ.dependsOn.field] || this.info[inactiveQ.dependsOn.field] === '')) {
          var altValue = this.questions.find((q) => q.field === inactiveQ.dependsOn.field).values.find((v) => !inactiveQ.dependsOn.values.includes(v.value)).value
          this.setField({ field: inactiveQ.dependsOn.field, value: altValue })
        }
      }
      this.inactivesPrepared = true
    },
    ensureAnswersAreValidOrNull () {
      this.questions.forEach((question) => {
        if (question.type !== 'HiddenField' && this.info[question.field] && this.info[question.field] !== '' && !question.values.some((v) => v.value === this.info[question.field])) {
          var realVal = question.values.find((v) => v.label === this.info[question.field])
          if (realVal) {
            this.setField({ field: question.field, value: realVal.value })
          } else {
            this.setField({ field: question.field, value: null })
          }
        }
      })
    },
    getReady () {
      this.isPrepped = true
    },
    changeField (field, value) {
      var fieldChange = { field, value }
      this.setField(fieldChange)
      this.setInactiveDefaults()
    },
    async save () {
      var questionsWithNoAnswer = this.activeQuestions.filter((q) => q.type !== 'OnlyLabel' && (typeof this.info[q.field] === 'undefined' || this.info[q.field] === null))
      if (questionsWithNoAnswer.length > 0) {
        var errors = {}
        questionsWithNoAnswer.forEach((q) => {
          errors[q.field] = 'can\'t be blank'
        })
        this.setErrors(errors)
        return
      }
      await this.setInactiveDefaults()
      await this.saveData()
      var errorKeys = Object.keys(this.infoErrors)
      if (errorKeys.length === 0) {
        this.$router.push(`/consumer/${this.consumerId}/offers`)
      } else {
        var hiddenErrors = errorKeys.filter((key) => this.activeQuestions.some((q) => q.type === 'HiddenField' && q.field === key))
        if (hiddenErrors.length > 0) {
          hiddenErrors.forEach((key) => {
            this.addConsumerError({ type: 'HiddenFieldError', field: key })
          })
          this.$router.push(`/consumer/${this.consumerId}/not-valid`)
        }
      }
    },
    async triggerResizeEvent () {
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 500)
    },
    setQuestionRef (el) {
      if (el) {
        this.questionRefs[el.question.field] = el
      }
    },
    nextPage () {
      var questionsWithNoAnswer = this.currentPageActiveQuestions.filter((q) => typeof this.info[q.field] === 'undefined' || this.info[q.field] === null)
      if (questionsWithNoAnswer.length > 0) {
        var errors = {}
        questionsWithNoAnswer.forEach((q) => {
          errors[q.field] = 'can\'t be blank'
        })
        this.setErrors(errors)
        return
      }
      if (this.currentPage < this.pages.length - 1) {
        this.currentPage++
      }
    },
    backPage () {
      if (this.currentPage > 0) {
        this.currentPage--
      }
    },
    ...mapMutations({
      setField: 'consumer/additionalInfo/setField',
      setErrors: 'consumer/additionalInfo/setErrors',
      addConsumerError: 'consumer/addConsumerError'
    }),
    ...mapActions({
      saveData: 'consumer/saveAdditionalData'
    })
  },
  computed: {
    displayReady () {
      return this.questions && this.questions.length > 0
    },
    activeQuestions () {
      return this.questions ? this.questions.filter((q) => !q.dependsOn || q.dependsOn.values.includes(this.info[q.dependsOn.field])) : []
    },
    currentPageActiveQuestions () {
      return this.activeQuestions.filter((q) => q.page === this.currentPage)
    },
    pageTitle () {
      return this.pages.length > 0 ? this.pages[this.currentPage].title : 'Additional Information'
    },
    inactiveQuestions () {
      return this.questions ? this.questions.filter((q) => q.dependsOn && !q.dependsOn.values.includes(this.info[q.dependsOn.field])) : []
    },
    isEditingPrimaryInfo () {
      return !this.leadSaved || this.editingPrimaryInfo
    },
    ...mapGetters({
      info: 'consumer/additionalInfo/getInfo',
      infoErrors: 'consumer/additionalInfo/getErrors',
      leadSaved: 'consumer/lead/isSaved',
      allowConsumerInfoEdit: 'consumer/allowConsumerInfoEdit'
    }),
    ...mapState({
      questions: state => state.consumer.additionalInfo.questions,
      pages: state => state.consumer.additionalInfo.pages,
      editingPrimaryInfo: state => state.consumer.editingPrimaryInfo,
      prefillReady: state => state.consumer.additionalInfo.prefillEvaluated
    })
  },
  mounted () {
    if (!this.inactivesPrepared && this.prefillReady) {
      this.prepareInactives()
      this.ensureAnswersAreValidOrNull()
    }
    // ensure component loads
    this.triggerResizeEvent()
  },
  watch: {
    prefillReady () {
      if (!this.inactivesPrepared) {
        this.prepareInactives()
        this.ensureAnswersAreValidOrNull()
      }
    },
    infoErrors (value) {
      if (value) {
        var errorKeys = Object.keys(value)
        for (var qIndex = 0; qIndex < this.activeQuestions.length; qIndex++) {
          if (errorKeys.includes(this.activeQuestions[qIndex].field)) {
            this.currentPage = this.activeQuestions[qIndex].page
            this.questionRefs[this.activeQuestions[qIndex].field].$el.scrollIntoView({ block: 'center' })
            this.isPrepped = false
            return
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.additional-info-manager {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 0 calc(var(--bs-gutter-x) / 2);
  margin-bottom: 15px;
}
.additional-info-manager .row {
  border-bottom: 1px solid lightgray;
  padding-top: 10px;
  padding-bottom: 15px;
}
.row.additional-info-footer {
  border: none;
  text-align: center;
}
.edit-icon svg{
  height: 2em;
}
.additional-info-header {
  font-size: 18px;
  background-color: #f5f5f5;
}
.additional-info-header .text-center {
  padding-top: 10px;
}
.additional-info-footer .btn {
  padding: 10px 20px;
}
.loading-holder {
  padding-top: 10vh;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  & div {
    padding-bottom: 10px;
  }
}
</style>
<style>
.question-error {
  color: red;
}
.additional-info-manager .question-label {
  font-weight: 700;
  padding-bottom: 10px;
}
@media screen and (min-width: 1200px) {
  .additional-info-manager .question-label {
    text-align: right;
  }
}

</style>
